import React from "react";
import { Button } from "../ui/button";
import { Card } from "../ui/card";
import { format, addMinutes, subMinutes } from "date-fns";
import { fr } from "date-fns/locale";
import presentationImage from "../../images/presentation.png";

const AppointmentConfirmationView = ({ appointment, onEnterVisio }) => {
  const now = new Date();

  // Calculer les créneaux d'accès avec marge de 15 minutes avant et après
  const appointmentStart = appointment?.dateTime
    ? subMinutes(appointment.dateTime, 15)
    : null;
  const appointmentEnd = appointment?.dateTime
    ? addMinutes(appointment.dateTime, 60)
    : null; // 45min + 15min de marge

  const isToday =
    appointment?.date && now.toDateString() === appointment.date.toDateString();
  const isInTimeWindow =
    appointmentStart &&
    appointmentEnd &&
    now >= appointmentStart &&
    now <= appointmentEnd;
  const isPastAppointment = appointmentEnd && now > appointmentEnd;

  return (
    <Card className="bg-white shadow-lg border-0 overflow-hidden m-4">
      <img
        src={presentationImage}
        alt="Groupe Lang & Associés - Expertise Automobile"
        className="w-full object-contain bg-gray-50"
      />
      <div className="p-6">
        <div className="space-y-4">
          <div className="text-center space-y-2">
            <div className="w-16 h-16 mx-auto bg-green-100 rounded-full flex items-center justify-center">
              <svg
                className="w-8 h-8 text-green-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                ></path>
              </svg>
            </div>
            <h2 className="text-lg font-semibold text-gray-900">
              Rendez-vous confirmé
            </h2>
          </div>

          {appointment && (
            <div className="bg-blue-50 border border-blue-200 rounded-md p-4">
              <div className="text-center space-y-1">
                <p className="text-sm font-medium text-blue-900">
                  Votre rendez-vous d'expertise
                </p>
                <p className="text-lg font-semibold text-blue-800">
                  {format(appointment.date, "EEEE d MMMM yyyy", { locale: fr })}
                </p>
                <p className="text-lg font-semibold text-blue-800">
                  à {appointment.time}
                </p>
                <p className="text-xs text-blue-700 mt-2">
                  Référence : {appointment.referenceNumber}
                </p>
              </div>
            </div>
          )}

          <div className="space-y-3">
            {isToday && isInTimeWindow && (
              <Button
                onClick={onEnterVisio}
                className="w-full h-10 bg-green-600 hover:bg-green-700 text-white text-sm font-medium rounded-md transition-colors"
              >
                Entrer en visioconférence
              </Button>
            )}

            {isToday && !isInTimeWindow && !isPastAppointment && (
              <div className="text-center p-4 bg-blue-50 border border-blue-200 rounded-md">
                <p className="text-sm text-blue-800">
                  Votre rendez-vous d'aujourd'hui sera accessible 15 minutes
                  avant l'heure prévue.
                </p>
                <p className="text-xs text-blue-600 mt-1">
                  Accès disponible à partir de{" "}
                  {appointmentStart ? format(appointmentStart, "HH:mm") : ""}
                </p>
              </div>
            )}

            {!isToday && !isPastAppointment && (
              <div className="text-center p-4 bg-yellow-50 border border-yellow-200 rounded-md">
                <p className="text-sm text-yellow-800">
                  Votre rendez-vous aura lieu le jour J. Revenez à cette date
                  pour entrer en visioconférence.
                </p>
              </div>
            )}

            {isPastAppointment && (
              <div className="text-center p-4 bg-gray-50 border border-gray-200 rounded-md">
                <p className="text-sm text-gray-600 mb-2">
                  Ce rendez-vous est passé.
                </p>
              </div>
            )}
          </div>

          <div className="mt-4 p-4 bg-red-50 border border-red-300 rounded-md">
            <p className="text-sm text-red-700 leading-relaxed">
              <strong>Note importante :</strong> Veuillez vous assurer d'avoir
              votre certificat d'immatriculation à disposition lors de la visioconférence,
              ainsi qu'une couverture réseau de qualité suffisante pour garantir
              le bon déroulement de l'expertise.
            </p>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default AppointmentConfirmationView;
